import React, { ReactNode } from 'react'
import Skeleton from 'react-loading-skeleton'

export const MenuHeader = ({
  header,
  badge
}: {
  header: string | null | undefined
  badge?: ReactNode
}) => {
  return (
    <h2>
      {header ? header : <Skeleton width='100%' height='100%' />}
      {badge ? <div className='headerBadge'>{badge}</div> : null}
    </h2>
  )
}
